import { StatusTagV2, ButtonV2 } from "../../../../Atoms";
import { MODALIDADE_POR_TIPO_ATENDIMENTO } from "../../../../../constants/modalidade_lote";
import {
  IAgendamentoResumidoDTO,
  ILoteAgendamentoTipoAtendimento,
} from "../../../../../types/loteAgendamento";

interface ICreatedAppointmentCardProps {
  agendamento: IAgendamentoResumidoDTO;
  tipoAtendimento: ILoteAgendamentoTipoAtendimento;
  identificador: "placa" | "chassi";
  servico?: string;
}

/**
 * One created appointment, rendered after a batch spreadsheet import
 * succeeds — kept page-local since only `BatchCreatedAppointments` maps a
 * list into repeated instances of this exact shape. Status pill reuses the
 * existing `StatusTagV2` Atom (already covers every `StatusAgendamentoEnum`
 * value); no new status component was needed.
 */
export const CreatedAppointmentCard = ({
  agendamento,
  tipoAtendimento,
  identificador,
  servico,
}: ICreatedAppointmentCardProps) => {
  const temFatura = !agendamento.revistoria && agendamento.fatura !== null;

  return (
    <div className="shrink-0 overflow-hidden rounded-3xl border border-solid border-[#e5e5ea] bg-white shadow-[0_8px_24px_0_rgba(0,0,0,0.078)]">
      <div className="flex flex-col gap-4 border-0 border-b border-solid border-b-[#e5e5ea] p-5 md:flex-row md:items-center md:gap-2.5">
        <div className="flex shrink-0 flex-col items-center gap-1 rounded-[10px] border border-dashed border-[#e5e5ea] bg-[#fafcfe] px-5 py-2.5">
          <span className="font-['Mulish'] text-[10px] text-[#2d2d2d]">
            {identificador === "placa" ? "Placa" : "Chassi"}
          </span>
          <span className="font-['Mulish'] text-base font-bold text-[#2d2d2d]">
            {agendamento.veiculo[identificador]}
          </span>
        </div>

        <div className="flex flex-1 flex-col gap-1">
          <span className="inline-flex w-fit items-center gap-1 rounded-full border border-solid border-[#e5e5ea] bg-[#fafcfe] px-2.5 py-0.5 font-['Mulish'] text-[10px] text-[#2d2d2d]">
            <img src="/assets/svgs/icon-place-small.svg" alt="" className="h-2.5 w-2.5" />
            {MODALIDADE_POR_TIPO_ATENDIMENTO[tipoAtendimento]}
          </span>
          <p className="font-['Mulish'] text-base font-bold text-[#2d2d2d]">
            {agendamento.cliente}
          </p>
          <p className="font-['Mulish'] text-[10px] text-[#2d2d2d]">
            {servico} - {agendamento.veiculo.modelo}
          </p>
          <p className="font-['Mulish'] text-[10px] text-[#2d2d2d]">{agendamento.local}</p>
        </div>

        <div className="flex flex-1 md:items-center md:justify-end">
          <StatusTagV2 status={agendamento.status} />
        </div>

        <div className="hidden flex-1 md:block" />
      </div>

      <div className="flex flex-wrap items-center justify-end gap-2.5 p-5">
        <ButtonV2
          href={`/meus-agendamentos/agendamento?id=${agendamento.uuid}`}
          target="_blank"
          rel="noreferrer"
          variant="text"
          className="h-auto w-auto min-w-0 gap-2 rounded-full border border-solid border-[#adb7b5] bg-[#adb7b5]/10 px-2 py-2 font-['Inter'] text-xs font-normal text-[#666]"
        >
          Ver detalhes
          <img src="/assets/svgs/icon-chevron-right.svg" alt="" className="h-3 w-3" />
        </ButtonV2>

        {temFatura && (
          <ButtonV2
            href={`/agendamento/${agendamento.uuid}/fatura`}
            target="_blank"
            rel="noreferrer"
            className="h-auto w-auto min-w-0 gap-2 rounded-full bg-[#ffcc00] px-2 py-2 font-['Inter'] text-xs font-normal text-black"
          >
            <img src="/assets/svgs/icon-fatura.svg" alt="" className="h-2.5 w-2.5" />
            Ver fatura
          </ButtonV2>
        )}
      </div>
    </div>
  );
};
